import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=87f9c4ce"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLanguagesSelect: require('/usr/src/app/components/ui/LanguagesSelect.vue').default,InputValidationInput: require('/usr/src/app/components/input/ValidationInput.vue').default,InputPhoneInput: require('/usr/src/app/components/input/PhoneInput.vue').default,Form: require('/usr/src/app/components/form/index.vue').default,ModalsModalDefault: require('/usr/src/app/components/modals/ModalDefault.vue').default})
